/* eslint-disable import/no-cycle */
import { action, computed, makeObservable, observable } from 'mobx';
import { PaymentCardStatus } from '../../swagger/api';
import { Filters, FilterMenuContent, FilterObject } from '../../Types';
import BaseStore from '../base-stores/BaseStore';
import { RootStore } from '../RootStore';

export enum PaymentCardsShowFilter {
  MyCards = 'MyCards'
}

export type PaymentCardsTableFilter = {
  show: FilterObject[];
  cardStatus: FilterObject[];
};
export default class PaymentCardsFilterStore extends BaseStore {
  allMenus: FilterMenuContent = {};

  activeFilters: PaymentCardsTableFilter = {
    show: [],
    cardStatus: []
  };

  temporaryFilters: PaymentCardsTableFilter = {
    show: [],
    cardStatus: []
  };

  searchVal: string = '';

  requestParams: {
    accountId: string;
    searchString?: string | undefined;
    cardStatus?: PaymentCardStatus[] | undefined;
  } = {
    accountId: ''
  };

  setRequestParams = () => {
    this.requestParams.searchString = this.searchVal;
    this.requestParams.cardStatus = this.activeFilters.cardStatus.map(
      (element: FilterObject) => element.filter as PaymentCardStatus
    );
  };

  get showOnlyMyCards() {
    return this.activeFilters.show.some(
      (element: FilterObject) => element.filter === PaymentCardsShowFilter.MyCards
    );
  }

  get hasActiveSearchOrFilters() {
    return (
      this.searchVal.trim() !== '' ||
      Object.values(this.activeFilters).some((filters: FilterObject[]) => filters.length > 0)
    );
  }

  setSearchVal = (searchString: string) => {
    this.searchVal = searchString;
    this.rootStore.administrationStore.administrationPaymentCardsStore.resetPages();
  };

  setActiveFilters = (temporaryFilters: Filters) => {
    this.activeFilters = JSON.parse(JSON.stringify(temporaryFilters));
    this.rootStore.administrationStore.administrationPaymentCardsStore.resetPages();
  };

  setTemporaryFilters = (filters: Filters) => {
    this.temporaryFilters = JSON.parse(JSON.stringify(filters));
  };

  resetPaymentCardsFilterStore = () => {
    const emptyFilter: PaymentCardsTableFilter = {
      show: [],
      cardStatus: []
    };
    this.setActiveFilters(emptyFilter);
    this.setTemporaryFilters(emptyFilter);
    this.setSearchVal('');
  };

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this, {
      allMenus: observable,
      activeFilters: observable,
      searchVal: observable,
      temporaryFilters: observable,
      showOnlyMyCards: computed,
      hasActiveSearchOrFilters: computed,
      setSearchVal: action,
      setActiveFilters: action
    });
  }
}
